export default __webpack_public_path__ + "static/media/Farrukh.c48bd057.webp";